import { Directive, ElementRef, AfterViewInit, Input } from '@angular/core';

@Directive({
  selector: '[appModalFocusOnInit]',
  standalone: true,
})
export class FocusOnInitDirective implements AfterViewInit {
  @Input() appFocusOnInit: number = 100; // Default timeout in milliseconds

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.el.nativeElement.focus();
    }, this.appFocusOnInit);
  }
}
